var map = {
	"./": 78525,
	"./151-rum-shot": 87430,
	"./151-rum-shot.json": 87430,
	"./aam-panna": 93669,
	"./aam-panna.json": 93669,
	"./aamras": 4652,
	"./aamras.json": 4652,
	"./abc-juice": 39814,
	"./abc-juice.json": 39814,
	"./across-the-pacific": 27308,
	"./across-the-pacific.json": 27308,
	"./adonis": 26613,
	"./adonis.json": 26613,
	"./adult-hot-chocolate": 82490,
	"./adult-hot-chocolate.json": 82490,
	"./affogato": 81876,
	"./affogato.json": 81876,
	"./afterglow": 18600,
	"./afterglow.json": 18600,
	"./agua-de-bandido": 43987,
	"./agua-de-bandido.json": 43987,
	"./agua-de-valencia": 91159,
	"./agua-de-valencia.json": 91159,
	"./aguapanela": 23886,
	"./aguapanela.json": 23886,
	"./airmail": 47584,
	"./airmail.json": 47584,
	"./ajoblanco": 70428,
	"./ajoblanco.json": 70428,
	"./alien-brain-hemorrhage": 23852,
	"./alien-brain-hemorrhage.json": 23852,
	"./almond-banana-smoothie": 13987,
	"./almond-banana-smoothie.json": 13987,
	"./amaretto-sour": 20026,
	"./amaretto-sour.json": 20026,
	"./amarula-thai-tea": 18326,
	"./amarula-thai-tea.json": 18326,
	"./american-trilogy": 52942,
	"./american-trilogy.json": 52942,
	"./americano": 77408,
	"./americano.json": 77408,
	"./amf": 80743,
	"./amf.json": 80743,
	"./amrit-chai": 74688,
	"./amrit-chai.json": 74688,
	"./angevine-soup": 49318,
	"./angevine-soup.json": 49318,
	"./aperol-spritz": 33431,
	"./aperol-spritz.json": 33431,
	"./apertass": 78134,
	"./apertass.json": 78134,
	"./apple-cider-margarita": 47110,
	"./apple-cider-margarita.json": 47110,
	"./apple-cider-mimosa": 43982,
	"./apple-cider-mimosa.json": 43982,
	"./apple-cider-mules": 91450,
	"./apple-cider-mules.json": 91450,
	"./apple-jack": 31081,
	"./apple-jack.json": 31081,
	"./apple-liqueur": 129,
	"./apple-liqueur.json": 129,
	"./apple-orchard-punch": 7696,
	"./apple-orchard-punch.json": 7696,
	"./apple-pie-cocktail": 16213,
	"./apple-pie-cocktail.json": 16213,
	"./appletini": 73957,
	"./appletini.json": 73957,
	"./april-rain": 24684,
	"./april-rain.json": 24684,
	"./aqueduct": 1237,
	"./aqueduct.json": 1237,
	"./argentinian-mate": 40685,
	"./argentinian-mate.json": 40685,
	"./astronaut": 43036,
	"./astronaut.json": 43036,
	"./aviation": 90530,
	"./aviation.json": 90530,
	"./ayran": 25092,
	"./ayran.json": 25092,
	"./b-52": 13103,
	"./b-52.json": 13103,
	"./baby-guinness": 21148,
	"./baby-guinness.json": 21148,
	"./bacardi-cocktail": 9842,
	"./bacardi-cocktail.json": 9842,
	"./bael-panna": 12194,
	"./bael-panna.json": 12194,
	"./bahama-mama": 76092,
	"./bahama-mama.json": 76092,
	"./bajigur": 60273,
	"./bajigur.json": 60273,
	"./banana-cocoa": 1554,
	"./banana-cocoa.json": 1554,
	"./banana-smoothie": 4595,
	"./banana-smoothie.json": 4595,
	"./bandrek": 72536,
	"./bandrek.json": 72536,
	"./bandung": 81226,
	"./bandung.json": 81226,
	"./bangkok-sunrise": 83956,
	"./bangkok-sunrise.json": 83956,
	"./barley-drink": 92431,
	"./barley-drink.json": 92431,
	"./barnamint-baileys": 81337,
	"./barnamint-baileys.json": 81337,
	"./barracuda": 59416,
	"./barracuda.json": 59416,
	"./barraquito": 12149,
	"./barraquito.json": 12149,
	"./basil-kadha": 44002,
	"./basil-kadha.json": 44002,
	"./basil-smash": 75961,
	"./basil-smash-pina-colada": 44671,
	"./basil-smash-pina-colada.json": 44671,
	"./basil-smash.json": 75961,
	"./batanga": 66131,
	"./batanga.json": 66131,
	"./bay-breeze": 42069,
	"./bay-breeze.json": 42069,
	"./beam-me-up-scotchie": 30798,
	"./beam-me-up-scotchie.json": 30798,
	"./beer-pletok": 55521,
	"./beer-pletok.json": 55521,
	"./beergarita": 89281,
	"./beergarita.json": 89281,
	"./bees-kiss": 70509,
	"./bees-kiss.json": 70509,
	"./bees-knees": 80541,
	"./bees-knees.json": 80541,
	"./bellini": 71150,
	"./bellini.json": 71150,
	"./bentley": 37892,
	"./bentley.json": 37892,
	"./beras-kencur": 25061,
	"./beras-kencur.json": 25061,
	"./berry-and-oat-smoothie": 80549,
	"./berry-and-oat-smoothie.json": 80549,
	"./berry-shrub": 7226,
	"./berry-shrub.json": 7226,
	"./berrylicious-frozen-sangria-slush": 22758,
	"./berrylicious-frozen-sangria-slush.json": 22758,
	"./beton": 34225,
	"./beton.json": 34225,
	"./between-the-sheets": 46336,
	"./between-the-sheets.json": 46336,
	"./bijou": 72986,
	"./bijou.json": 72986,
	"./bikini-martini": 39498,
	"./bikini-martini.json": 39498,
	"./birthday-cake-shot": 23266,
	"./birthday-cake-shot.json": 23266,
	"./bitter-but-good": 78149,
	"./bitter-but-good.json": 78149,
	"./black-martini": 83559,
	"./black-martini.json": 83559,
	"./black-russian": 19096,
	"./black-russian.json": 19096,
	"./black-velvet": 53621,
	"./black-velvet.json": 53621,
	"./black-widow": 42679,
	"./black-widow.json": 42679,
	"./blackberry-thyme-margarita": 82107,
	"./blackberry-thyme-margarita.json": 82107,
	"./blackthorn-cocktail": 35426,
	"./blackthorn-cocktail.json": 35426,
	"./blood-and-sand": 14264,
	"./blood-and-sand.json": 14264,
	"./blood-orange-champagne-mule": 96227,
	"./blood-orange-champagne-mule.json": 96227,
	"./bloody-eyeball-shot": 49342,
	"./bloody-eyeball-shot.json": 49342,
	"./bloody-geisha": 98138,
	"./bloody-geisha.json": 98138,
	"./bloody-kirby": 63776,
	"./bloody-kirby.json": 63776,
	"./bloody-mary": 35138,
	"./bloody-mary.json": 35138,
	"./blow-job-cocktail": 42120,
	"./blow-job-cocktail.json": 42120,
	"./blue-hawaiian-cocktail": 39403,
	"./blue-hawaiian-cocktail.json": 39403,
	"./blue-kamikaze-shot": 63606,
	"./blue-kamikaze-shot.json": 63606,
	"./blue-lady": 74040,
	"./blue-lady.json": 74040,
	"./blue-lagoon": 37032,
	"./blue-lagoon.json": 37032,
	"./blue-monday": 31056,
	"./blue-monday.json": 31056,
	"./blue-oasis": 58689,
	"./blue-oasis.json": 58689,
	"./blue-vodka-lemonade": 20525,
	"./blue-vodka-lemonade.json": 20525,
	"./blueberry-banana-smoothie": 87394,
	"./blueberry-banana-smoothie.json": 87394,
	"./boba-tea": 35280,
	"./boba-tea.json": 35280,
	"./bobby-burns": 27586,
	"./bobby-burns.json": 27586,
	"./bombeirinho": 87589,
	"./bombeirinho.json": 87589,
	"./boomerang": 21707,
	"./boomerang.json": 21707,
	"./boulevardier": 80147,
	"./boulevardier.json": 80147,
	"./bourbon-lemonade": 60786,
	"./bourbon-lemonade.json": 60786,
	"./bourbon-mule": 59798,
	"./bourbon-mule.json": 59798,
	"./bourbon-old-fashioned": 77704,
	"./bourbon-old-fashioned.json": 77704,
	"./boza": 14255,
	"./boza.json": 14255,
	"./brain-damage": 83687,
	"./brain-damage.json": 83687,
	"./bramble": 7568,
	"./bramble.json": 7568,
	"./brandy-alexander": 14862,
	"./brandy-alexander.json": 14862,
	"./brandy-sour": 41433,
	"./brandy-sour.json": 41433,
	"./brandy-wine-punch": 14948,
	"./brandy-wine-punch.json": 14948,
	"./brass-monkey": 52920,
	"./brass-monkey.json": 52920,
	"./brazilian-coconut-cocktail": 85024,
	"./brazilian-coconut-cocktail.json": 85024,
	"./brazilian-limeade": 54363,
	"./brazilian-limeade.json": 54363,
	"./brazilian-strawberry-drink": 41394,
	"./brazilian-strawberry-drink.json": 41394,
	"./breakfast-club-cocktail": 46746,
	"./breakfast-club-cocktail.json": 46746,
	"./breakfast-mai-tai": 93065,
	"./breakfast-mai-tai.json": 93065,
	"./breakfast-martini": 79253,
	"./breakfast-martini.json": 79253,
	"./bruce-wayne": 89395,
	"./bruce-wayne.json": 89395,
	"./brunswick-cocktail": 98342,
	"./brunswick-cocktail.json": 98342,
	"./buffalo-sweat": 51571,
	"./buffalo-sweat.json": 51571,
	"./bullfisher": 24353,
	"./bullfisher.json": 24353,
	"./burnt-caramel-manhattan": 15269,
	"./burnt-caramel-manhattan.json": 15269,
	"./butter-coffee": 11582,
	"./butter-coffee.json": 11582,
	"./buttermilk": 98848,
	"./buttermilk.json": 98848,
	"./buttery-nipple": 33339,
	"./buttery-nipple.json": 33339,
	"./cable-car": 63241,
	"./cable-car.json": 63241,
	"./cafeconleche": 76579,
	"./cafeconleche.json": 76579,
	"./caferio-cookie-shake": 3796,
	"./caferio-cookie-shake.json": 3796,
	"./caipipink": 24771,
	"./caipipink.json": 24771,
	"./caipireja": 84491,
	"./caipireja.json": 84491,
	"./caipirinha": 50195,
	"./caipirinha-black": 9137,
	"./caipirinha-black.json": 9137,
	"./caipirinha-red-fruit": 9778,
	"./caipirinha-red-fruit.json": 9778,
	"./caipirinha.json": 50195,
	"./caipiroska": 91997,
	"./caipiroska.json": 91997,
	"./calamansi-juice": 22111,
	"./calamansi-juice.json": 22111,
	"./calamity-jane": 17738,
	"./calamity-jane.json": 17738,
	"./californication": 71162,
	"./californication.json": 71162,
	"./canelazo": 40408,
	"./canelazo.json": 40408,
	"./cantarito-tequila": 87880,
	"./cantarito-tequila.json": 87880,
	"./cape-codder": 2372,
	"./cape-codder.json": 2372,
	"./capeta": 65741,
	"./capeta.json": 65741,
	"./cappuccino": 97498,
	"./cappuccino.json": 97498,
	"./carajillo": 9954,
	"./carajillo.json": 9954,
	"./caramel-apple-shot": 59422,
	"./caramel-apple-shot.json": 59422,
	"./caramel-frappuccino": 16055,
	"./caramel-frappuccino.json": 16055,
	"./caramel-snickerdoodle-martini": 39480,
	"./caramel-snickerdoodle-martini.json": 39480,
	"./carrulim": 91870,
	"./carrulim.json": 91870,
	"./casino": 30982,
	"./casino.json": 30982,
	"./cement-mixer": 61037,
	"./cement-mixer.json": 61037,
	"./cendol": 61996,
	"./cendol.json": 61996,
	"./chai-e-zanjafeel": 36075,
	"./chai-e-zanjafeel.json": 36075,
	"./champagne-soup": 96459,
	"./champagne-soup.json": 96459,
	"./cheerwine": 50467,
	"./cheerwine.json": 50467,
	"./cherry-bourbon-smash": 49743,
	"./cherry-bourbon-smash.json": 49743,
	"./cherry-limeade": 86678,
	"./cherry-limeade.json": 86678,
	"./chikoo-lassi": 97897,
	"./chikoo-lassi.json": 97897,
	"./chocolate-cake-shot": 14631,
	"./chocolate-cake-shot.json": 14631,
	"./chocolate-milk": 98423,
	"./chocolate-milk.json": 98423,
	"./chocolate-monkey": 23449,
	"./chocolate-monkey.json": 23449,
	"./chocoline": 15855,
	"./chocoline.json": 15855,
	"./christmas-tonic": 3879,
	"./christmas-tonic.json": 3879,
	"./chuhai": 21329,
	"./chuhai.json": 21329,
	"./churchill": 37565,
	"./churchill.json": 37565,
	"./cinnamon-maple-whiskey": 13541,
	"./cinnamon-maple-whiskey.json": 13541,
	"./citrus-martini": 80376,
	"./citrus-martini.json": 80376,
	"./clarito": 15077,
	"./clarito.json": 15077,
	"./classic-whiskey-sour": 61058,
	"./classic-whiskey-sour.json": 61058,
	"./clavis-riga": 29297,
	"./clavis-riga.json": 29297,
	"./clericot": 12890,
	"./clericot.json": 12890,
	"./clover-club-cocktail": 31400,
	"./clover-club-cocktail.json": 31400,
	"./coco-avocado": 80097,
	"./coco-avocado.json": 80097,
	"./coco-dream": 51735,
	"./coco-dream.json": 51735,
	"./coco-loco": 17223,
	"./coco-loco.json": 17223,
	"./coco-piñarita": 55479,
	"./coco-piñarita.json": 55479,
	"./coconut-coffee": 98023,
	"./coconut-coffee.json": 98023,
	"./coconut-lime-cilantro-cooler": 91996,
	"./coconut-lime-cilantro-cooler.json": 91996,
	"./coconut-margarita": 17463,
	"./coconut-margarita.json": 17463,
	"./coconut-mint-collins": 91584,
	"./coconut-mint-collins.json": 91584,
	"./cold-brew": 90,
	"./cold-brew-old-fashioned": 41802,
	"./cold-brew-old-fashioned.json": 41802,
	"./cold-brew.json": 90,
	"./cold-coffee": 39046,
	"./cold-coffee.json": 39046,
	"./cold-relief-tea": 47920,
	"./cold-relief-tea.json": 47920,
	"./colombian-michelada": 84042,
	"./colombian-michelada.json": 84042,
	"./colorado-bulldog": 45322,
	"./colorado-bulldog.json": 45322,
	"./comfort-colllins": 4212,
	"./comfort-colllins.json": 4212,
	"./coquito": 19049,
	"./coquito.json": 19049,
	"./corn-juice": 63942,
	"./corn-juice.json": 63942,
	"./coronarita": 86823,
	"./coronarita.json": 86823,
	"./corpse-reviver-no2": 18608,
	"./corpse-reviver-no2.json": 18608,
	"./cosmopolitan": 88801,
	"./cosmopolitan.json": 88801,
	"./cranberry-bourbon": 5067,
	"./cranberry-bourbon.json": 5067,
	"./cranberry-mimosa": 24978,
	"./cranberry-mimosa.json": 24978,
	"./cranberry-orange-whiskey": 76173,
	"./cranberry-orange-whiskey.json": 76173,
	"./cranberry-tonic": 34877,
	"./cranberry-tonic.json": 34877,
	"./creamy-indian-espresso": 71271,
	"./creamy-indian-espresso.json": 71271,
	"./creamy-mango-lassi": 94518,
	"./creamy-mango-lassi.json": 94518,
	"./creole-cream": 37068,
	"./creole-cream.json": 37068,
	"./crock-pot-butterbeer-rum": 83473,
	"./crock-pot-butterbeer-rum.json": 83473,
	"./crusta": 315,
	"./crusta.json": 315,
	"./cuba-libre": 10791,
	"./cuba-libre.json": 10791,
	"./cuban-zombie": 6267,
	"./cuban-zombie.json": 6267,
	"./cucumber-gin": 25094,
	"./cucumber-gin.json": 25094,
	"./cucumber-lemonade": 19961,
	"./cucumber-lemonade.json": 19961,
	"./cucumber-lime-mint-agua-fresca": 91420,
	"./cucumber-lime-mint-agua-fresca.json": 91420,
	"./cynar-spritz": 41213,
	"./cynar-spritz.json": 41213,
	"./daddy-dont-go": 880,
	"./daddy-dont-go.json": 880,
	"./daiquiri": 39207,
	"./daiquiri.json": 39207,
	"./dalgona-coffee": 52604,
	"./dalgona-coffee.json": 52604,
	"./danish-summer": 85770,
	"./danish-summer.json": 85770,
	"./dark-and-stormy": 26868,
	"./dark-and-stormy.json": 26868,
	"./dawet-rice-flours": 98914,
	"./dawet-rice-flours.json": 98914,
	"./dayak-onion-tea": 47294,
	"./dayak-onion-tea.json": 47294,
	"./death-in-the-afternoon": 74084,
	"./death-in-the-afternoon.json": 74084,
	"./death-in-the-gulf-stream": 7981,
	"./death-in-the-gulf-stream.json": 7981,
	"./debonair": 78139,
	"./debonair.json": 78139,
	"./desert-colada": 38673,
	"./desert-colada.json": 38673,
	"./desi-borhani": 35566,
	"./desi-borhani.json": 35566,
	"./detox-green-juice": 41542,
	"./detox-green-juice.json": 41542,
	"./detox-green-tea": 58220,
	"./detox-green-tea.json": 58220,
	"./devils-ice-tea": 10395,
	"./devils-ice-tea.json": 10395,
	"./devils-own": 43851,
	"./devils-own.json": 43851,
	"./dianas-lips": 30682,
	"./dianas-lips.json": 30682,
	"./dirty-snowmen": 9147,
	"./dirty-snowmen.json": 9147,
	"./dolce-vita": 62477,
	"./dolce-vita.json": 62477,
	"./dole-whip-lemonade": 71814,
	"./dole-whip-lemonade.json": 71814,
	"./dom-pedro": 78008,
	"./dom-pedro.json": 78008,
	"./doodh-cola": 12429,
	"./doodh-cola.json": 12429,
	"./dorflinger": 66727,
	"./dorflinger.json": 66727,
	"./dr-disaronno": 46575,
	"./dr-disaronno.json": 46575,
	"./dragon-fruit-smoothie": 71400,
	"./dragon-fruit-smoothie.json": 71400,
	"./dragons-breath-mojito": 82507,
	"./dragons-breath-mojito.json": 82507,
	"./drunken-monkey": 360,
	"./drunken-monkey.json": 360,
	"./drunken-peanut-butter-cups": 80237,
	"./drunken-peanut-butter-cups.json": 80237,
	"./dubliner": 7592,
	"./dubliner.json": 7592,
	"./dutchmans-daiquiri": 24769,
	"./dutchmans-daiquiri.json": 24769,
	"./earl-grey-gin-tea": 9827,
	"./earl-grey-gin-tea.json": 9827,
	"./easy-sangria": 711,
	"./easy-sangria.json": 711,
	"./egg-coffee": 84641,
	"./egg-coffee.json": 84641,
	"./eggnog": 29450,
	"./eggnog.json": 29450,
	"./egyptian-fakhfakhina": 96891,
	"./egyptian-fakhfakhina.json": 96891,
	"./egyptian-sobia-drink": 35228,
	"./egyptian-sobia-drink.json": 35228,
	"./el-diablo": 71782,
	"./el-diablo.json": 71782,
	"./el-presidente": 37432,
	"./el-presidente.json": 37432,
	"./elderflower-cooler": 64529,
	"./elderflower-cooler.json": 64529,
	"./elderflower-french-75": 12782,
	"./elderflower-french-75.json": 12782,
	"./elderflower-tini": 28133,
	"./elderflower-tini.json": 28133,
	"./embuscade": 40948,
	"./embuscade.json": 40948,
	"./english-garden-cocktail": 76168,
	"./english-garden-cocktail.json": 76168,
	"./es-jeruk": 91325,
	"./es-jeruk.json": 91325,
	"./es-sarang-burung": 9542,
	"./es-sarang-burung.json": 9542,
	"./espanhola": 82138,
	"./espanhola.json": 82138,
	"./espresso-martini": 66626,
	"./espresso-martini.json": 66626,
	"./fall-old-fashioned": 98116,
	"./fall-old-fashioned.json": 98116,
	"./fast-food-classic": 33279,
	"./fast-food-classic.json": 33279,
	"./fernet-with-coke": 69037,
	"./fernet-with-coke.json": 69037,
	"./fig-bourbon-cider-smash": 6892,
	"./fig-bourbon-cider-smash.json": 6892,
	"./figaro-cocktail": 15264,
	"./figaro-cocktail.json": 15264,
	"./fireball-hot-toddies": 15819,
	"./fireball-hot-toddies.json": 15819,
	"./fireball-shot": 24191,
	"./fireball-shot.json": 24191,
	"./firetruck": 83324,
	"./firetruck-emergency-response": 28032,
	"./firetruck-emergency-response.json": 28032,
	"./firetruck.json": 83324,
	"./flaming-engineer": 18700,
	"./flaming-engineer.json": 18700,
	"./flaming-moe": 4485,
	"./flaming-moe.json": 4485,
	"./four-horsemen-shot": 54830,
	"./four-horsemen-shot.json": 54830,
	"./french-75": 28856,
	"./french-75.json": 28856,
	"./french-martini": 95522,
	"./french-martini.json": 95522,
	"./french-pearl": 20212,
	"./french-pearl.json": 20212,
	"./french-sangria": 9013,
	"./french-sangria.json": 9013,
	"./frose": 42998,
	"./frose.json": 42998,
	"./frosted-lemonade": 45314,
	"./frosted-lemonade.json": 45314,
	"./frozen-cantaloupe-margarita": 37809,
	"./frozen-cantaloupe-margarita.json": 37809,
	"./fuzzy-navel": 39790,
	"./fuzzy-navel.json": 39790,
	"./galack-colada": 65001,
	"./galack-colada.json": 65001,
	"./galaxie": 5836,
	"./galaxie.json": 5836,
	"./gazpacho": 28006,
	"./gazpacho.json": 28006,
	"./gibson": 12499,
	"./gibson.json": 12499,
	"./gimlet": 20977,
	"./gimlet.json": 20977,
	"./gin-coke": 2962,
	"./gin-coke.json": 2962,
	"./gin-elderflower-fizz": 98435,
	"./gin-elderflower-fizz.json": 98435,
	"./gin-fizz": 88905,
	"./gin-fizz-with-pomegranate": 88690,
	"./gin-fizz-with-pomegranate.json": 88690,
	"./gin-fizz.json": 88905,
	"./gin-sour": 45317,
	"./gin-sour.json": 45317,
	"./gin-tonic": 64325,
	"./gin-tonic.json": 64325,
	"./gin-tonica": 24440,
	"./gin-tonica.json": 24440,
	"./ginger-infused-water": 51256,
	"./ginger-infused-water.json": 51256,
	"./ginger-lemon-tea": 59372,
	"./ginger-lemon-tea.json": 59372,
	"./ginger-lime-whiskey-sour": 37768,
	"./ginger-lime-whiskey-sour.json": 37768,
	"./ginger-milk-tea": 89108,
	"./ginger-milk-tea.json": 89108,
	"./ginger-mint-tea": 13751,
	"./ginger-mint-tea.json": 13751,
	"./gingerbread-eggnog": 5175,
	"./gingerbread-eggnog.json": 5175,
	"./gingerbread-latte": 16770,
	"./gingerbread-latte.json": 16770,
	"./glogg": 11549,
	"./glogg.json": 11549,
	"./gluhwein": 39032,
	"./gluhwein.json": 39032,
	"./godchild": 56577,
	"./godchild.json": 56577,
	"./godfather": 81659,
	"./godfather.json": 81659,
	"./golden-brown": 41009,
	"./golden-brown.json": 41009,
	"./golden-glow-water": 23404,
	"./golden-glow-water.json": 23404,
	"./golden-slipper": 17364,
	"./golden-slipper.json": 17364,
	"./good-vibrations": 41344,
	"./good-vibrations.json": 41344,
	"./grandmas-apple-pie-ala-mode-moonshine": 31228,
	"./grandmas-apple-pie-ala-mode-moonshine.json": 31228,
	"./grass-jelly-drink": 34451,
	"./grass-jelly-drink.json": 34451,
	"./grasshopper": 89047,
	"./grasshopper.json": 89047,
	"./green-beast": 50722,
	"./green-beast.json": 50722,
	"./green-lagoon": 19363,
	"./green-lagoon.json": 19363,
	"./green-mango-sharbat": 36349,
	"./green-mango-sharbat.json": 36349,
	"./greyhound": 19844,
	"./greyhound.json": 19844,
	"./grilled-grapefruit-paloma-cocktail": 90762,
	"./grilled-grapefruit-paloma-cocktail.json": 90762,
	"./grinch-drinks": 16648,
	"./grinch-drinks.json": 16648,
	"./grog": 20462,
	"./grog.json": 20462,
	"./guarapita": 43373,
	"./guarapita.json": 43373,
	"./guayacolita": 97424,
	"./guayacolita.json": 97424,
	"./hanky-panky": 55242,
	"./hanky-panky.json": 55242,
	"./happy-soda": 50377,
	"./happy-soda.json": 50377,
	"./hard-applecider": 6632,
	"./hard-applecider.json": 6632,
	"./harry-potter-butterbeer": 7009,
	"./harry-potter-butterbeer.json": 7009,
	"./hi-fi": 89600,
	"./hi-fi.json": 89600,
	"./hibiscus-cherry-vodka-spritz": 48044,
	"./hibiscus-cherry-vodka-spritz.json": 48044,
	"./hibiscus-mint-tea": 42215,
	"./hibiscus-mint-tea.json": 42215,
	"./hiroshima": 31675,
	"./hiroshima.json": 31675,
	"./hocus-pocus": 83190,
	"./hocus-pocus.json": 83190,
	"./homemade-blackberry-lemonade": 96615,
	"./homemade-blackberry-lemonade.json": 96615,
	"./homemade-whiteclaw": 80860,
	"./homemade-whiteclaw.json": 80860,
	"./honey-bee-mine": 77123,
	"./honey-bee-mine.json": 77123,
	"./honey-carrot": 20128,
	"./honey-carrot.json": 20128,
	"./honey-egg-juice": 80889,
	"./honey-egg-juice.json": 80889,
	"./honey-spearmint-tea": 9271,
	"./honey-spearmint-tea.json": 9271,
	"./horachata": 86402,
	"./horachata.json": 86402,
	"./horchata-water": 22281,
	"./horchata-water.json": 22281,
	"./hot-buttered-rum": 8937,
	"./hot-buttered-rum.json": 8937,
	"./hot-espresso": 98263,
	"./hot-espresso.json": 98263,
	"./hot-toddy": 99793,
	"./hot-toddy.json": 99793,
	"./hot-water": 92056,
	"./hot-water.json": 92056,
	"./hugo": 21372,
	"./hugo.json": 21372,
	"./hurricane": 63668,
	"./hurricane.json": 63668,
	"./ice-cold-water": 17923,
	"./ice-cold-water.json": 17923,
	"./iced-coffee-frappe": 60344,
	"./iced-coffee-frappe.json": 60344,
	"./iced-matcha-latte": 72488,
	"./iced-matcha-latte.json": 72488,
	"./immune-boosting-smoothie": 67169,
	"./immune-boosting-smoothie.json": 67169,
	"./income-tax": 58226,
	"./income-tax.json": 58226,
	"./index": 78525,
	"./index.js": 78525,
	"./indian-summer": 39632,
	"./indian-summer.json": 39632,
	"./indonesian-avocado-milkshake": 56131,
	"./indonesian-avocado-milkshake.json": 56131,
	"./irish-blues": 4110,
	"./irish-blues.json": 4110,
	"./irish-breakfast-shot": 92389,
	"./irish-breakfast-shot.json": 92389,
	"./irish-car-bomb": 66708,
	"./irish-car-bomb.json": 66708,
	"./irish-coffee": 78253,
	"./irish-coffee.json": 78253,
	"./irish-winter": 3604,
	"./irish-winter.json": 3604,
	"./italian-cream-soda": 97818,
	"./italian-cream-soda.json": 97818,
	"./jack-frosties": 74896,
	"./jack-frosties.json": 74896,
	"./jacqueline": 25512,
	"./jacqueline.json": 25512,
	"./jager-ginger": 32993,
	"./jager-ginger.json": 32993,
	"./jagerbomb": 42530,
	"./jagerbomb.json": 42530,
	"./jaljeera": 66333,
	"./jaljeera.json": 66333,
	"./jam-band": 31285,
	"./jam-band.json": 31285,
	"./jamaican-mule": 13973,
	"./jamaican-mule.json": 13973,
	"./jammy-dodger-shot": 45502,
	"./jammy-dodger-shot.json": 45502,
	"./jamun-panna": 32391,
	"./jamun-panna.json": 32391,
	"./jamun-shots": 81296,
	"./jamun-shots.json": 81296,
	"./japanese-highball": 6092,
	"./japanese-highball.json": 6092,
	"./japanese-ice-tea": 9023,
	"./japanese-ice-tea.json": 9023,
	"./jasmine-milk-tea": 53233,
	"./jasmine-milk-tea.json": 53233,
	"./jaunelemonricard": 10614,
	"./jaunelemonricard.json": 10614,
	"./jello-shots": 9365,
	"./jello-shots.json": 9365,
	"./jungle-bird": 38704,
	"./jungle-bird.json": 38704,
	"./kalimotxo": 68567,
	"./kalimotxo.json": 68567,
	"./kamikaze-shot": 45253,
	"./kamikaze-shot.json": 45253,
	"./kansas-city-ice-water": 238,
	"./kansas-city-ice-water.json": 238,
	"./karkade": 22358,
	"./karkade.json": 22358,
	"./kenyan-dawa": 39673,
	"./kenyan-dawa.json": 39673,
	"./kerala-sunset": 4300,
	"./kerala-sunset.json": 4300,
	"./khoshaf": 75831,
	"./khoshaf.json": 75831,
	"./kiba-smoothie": 45507,
	"./kiba-smoothie.json": 45507,
	"./kids-hot-chocolate": 28405,
	"./kids-hot-chocolate.json": 28405,
	"./killer": 99542,
	"./killer.json": 99542,
	"./kir-royale": 21146,
	"./kir-royale.json": 21146,
	"./kiwi-caipisake": 89872,
	"./kiwi-caipisake.json": 89872,
	"./kiwi-cucumber-cooler": 19769,
	"./kiwi-cucumber-cooler.json": 19769,
	"./kokam-sherbat": 18960,
	"./kokam-sherbat.json": 18960,
	"./kokum-stings": 87463,
	"./kokum-stings.json": 87463,
	"./kombucha-vodka-highball": 54959,
	"./kombucha-vodka-highball.json": 54959,
	"./kopi": 9044,
	"./kopi.json": 9044,
	"./la-vie-en-rose": 13219,
	"./la-vie-en-rose.json": 13219,
	"./lafayette": 22348,
	"./lafayette.json": 22348,
	"./latte": 63365,
	"./latte.json": 63365,
	"./lava-flow": 51266,
	"./lava-flow.json": 51266,
	"./lavender-basil-lemonade": 31218,
	"./lavender-basil-lemonade.json": 31218,
	"./lavender-latte": 58297,
	"./lavender-latte.json": 58297,
	"./lazy-sunday": 8710,
	"./lazy-sunday.json": 8710,
	"./lemon-cointreau-fizz": 39293,
	"./lemon-cointreau-fizz.json": 39293,
	"./lemon-drop": 28658,
	"./lemon-drop.json": 28658,
	"./lemon-stylus": 16373,
	"./lemon-stylus.json": 16373,
	"./lemonade": 35200,
	"./lemonade.json": 35200,
	"./libertine": 31109,
	"./libertine.json": 31109,
	"./lillet-buck": 92221,
	"./lillet-buck.json": 92221,
	"./lime-mojito": 74143,
	"./lime-mojito.json": 74143,
	"./limerol": 12453,
	"./limerol.json": 12453,
	"./limoncello-spritz": 6252,
	"./limoncello-spritz.json": 6252,
	"./london-fog": 16018,
	"./london-fog.json": 16018,
	"./long-island-iced-tea": 57772,
	"./long-island-iced-tea.json": 57772,
	"./lust-for-life": 28332,
	"./lust-for-life.json": 28332,
	"./lynchburg-lemonade": 1925,
	"./lynchburg-lemonade.json": 1925,
	"./macunaima": 86747,
	"./macunaima.json": 86747,
	"./madeleine": 67943,
	"./madeleine.json": 67943,
	"./madras": 14137,
	"./madras.json": 14137,
	"./magic-eye-juice": 94245,
	"./magic-eye-juice.json": 94245,
	"./mai-tai": 76517,
	"./mai-tai.json": 76517,
	"./malibu-island-cosmo": 52359,
	"./malibu-island-cosmo.json": 52359,
	"./malibu-sunset": 34826,
	"./malibu-sunset.json": 34826,
	"./mangalorean-tea": 35439,
	"./mangalorean-tea.json": 35439,
	"./mango-daiquiri": 46774,
	"./mango-daiquiri.json": 46774,
	"./mango-iced-tea": 98582,
	"./mango-iced-tea.json": 98582,
	"./mango-juice": 41220,
	"./mango-juice.json": 41220,
	"./mango-lassi": 68228,
	"./mango-lassi.json": 68228,
	"./mango-mastani": 60817,
	"./mango-mastani.json": 60817,
	"./mango-mocktail": 97480,
	"./mango-mocktail.json": 97480,
	"./mango-nojito-mocktail": 60422,
	"./mango-nojito-mocktail.json": 60422,
	"./mango-peach-smoothie": 17772,
	"./mango-peach-smoothie.json": 17772,
	"./mango-shake": 43610,
	"./mango-shake.json": 43610,
	"./mango-yakult-juice": 69947,
	"./mango-yakult-juice.json": 69947,
	"./manhattan": 30267,
	"./manhattan.json": 30267,
	"./maple-bourbon-smash": 8673,
	"./maple-bourbon-smash.json": 8673,
	"./margarita": 17501,
	"./margarita.json": 17501,
	"./marpha": 74666,
	"./marpha.json": 74666,
	"./marquisette": 61427,
	"./marquisette.json": 61427,
	"./martini": 72625,
	"./martini-royale": 46158,
	"./martini-royale.json": 46158,
	"./martini.json": 72625,
	"./masala-chaas": 68015,
	"./masala-chaas.json": 68015,
	"./masala-chai": 38634,
	"./masala-chai.json": 38634,
	"./masala-coke": 81097,
	"./masala-coke.json": 81097,
	"./matcha-green-russian": 97451,
	"./matcha-green-russian.json": 97451,
	"./matcha-green-tea-smoothie": 63551,
	"./matcha-green-tea-smoothie.json": 63551,
	"./matcha-latte": 50002,
	"./matcha-latte.json": 50002,
	"./medicine-ball-tea": 24778,
	"./medicine-ball-tea.json": 24778,
	"./meia-de-seda": 46833,
	"./meia-de-seda.json": 46833,
	"./mexican-candy-shot": 7825,
	"./mexican-candy-shot.json": 7825,
	"./mexican-lagrimas-de-virgen": 80043,
	"./mexican-lagrimas-de-virgen.json": 80043,
	"./mexican-mule": 17096,
	"./mexican-mule.json": 17096,
	"./mexican-sonora-michelada": 8900,
	"./mexican-sonora-michelada.json": 8900,
	"./mexican-strawberry-water": 2506,
	"./mexican-strawberry-water.json": 2506,
	"./mezcal-with-jalapeno-pepper": 18148,
	"./mezcal-with-jalapeno-pepper.json": 18148,
	"./miami-vice": 5786,
	"./miami-vice.json": 5786,
	"./michelada-zero-proof": 91803,
	"./michelada-zero-proof.json": 91803,
	"./midnight-in-paris": 89185,
	"./midnight-in-paris.json": 89185,
	"./milk-punch": 39147,
	"./milk-punch.json": 39147,
	"./milk-tea": 96981,
	"./milk-tea.json": 96981,
	"./milo-dinosaur": 3858,
	"./milo-dinosaur.json": 3858,
	"./mimosa": 29239,
	"./mimosa.json": 29239,
	"./mind-eraser": 22356,
	"./mind-eraser.json": 22356,
	"./mint-chocolate-milkshake": 2800,
	"./mint-chocolate-milkshake.json": 2800,
	"./mint-citrus-water": 62388,
	"./mint-citrus-water.json": 62388,
	"./mint-julep": 40890,
	"./mint-julep.json": 40890,
	"./mix-berry": 99828,
	"./mix-berry.json": 99828,
	"./mocha": 15065,
	"./mocha.json": 15065,
	"./mojito": 17113,
	"./mojito.json": 17113,
	"./monaco": 66030,
	"./monaco.json": 66030,
	"./monkey-gland": 12393,
	"./monkey-gland.json": 12393,
	"./montreal-mule": 34051,
	"./montreal-mule.json": 34051,
	"./moscato-mules": 54208,
	"./moscato-mules.json": 54208,
	"./moscow-breeze": 87283,
	"./moscow-breeze.json": 87283,
	"./moscow-mule": 95553,
	"./moscow-mule-simple": 50270,
	"./moscow-mule-simple.json": 50270,
	"./moscow-mule.json": 95553,
	"./mr-peanut-shake": 98047,
	"./mr-peanut-shake.json": 98047,
	"./mudslide": 70022,
	"./mudslide.json": 70022,
	"./mulled-apple-crumble-cider": 5388,
	"./mulled-apple-crumble-cider.json": 5388,
	"./mulled-wine": 3032,
	"./mulled-wine.json": 3032,
	"./muskmelon-panaka": 28465,
	"./muskmelon-panaka.json": 28465,
	"./nam-thom": 57138,
	"./nam-thom.json": 57138,
	"./nannari-sarabath": 20669,
	"./nannari-sarabath.json": 20669,
	"./negroni": 99271,
	"./negroni-sbagliato": 64610,
	"./negroni-sbagliato.json": 64610,
	"./negroni.json": 99271,
	"./negroski": 3515,
	"./negroski.json": 3515,
	"./negrumi": 91642,
	"./negrumi.json": 91642,
	"./nevada": 18898,
	"./nevada.json": 18898,
	"./new-york-sour": 96015,
	"./new-york-sour.json": 96015,
	"./newfoundland-christmas-slush": 9375,
	"./newfoundland-christmas-slush.json": 9375,
	"./nice-holiday": 7493,
	"./nice-holiday.json": 7493,
	"./nigerian-chapman": 9625,
	"./nigerian-chapman.json": 9625,
	"./nimbu-pani": 34291,
	"./nimbu-pani.json": 34291,
	"./noche-caliente": 46908,
	"./noche-caliente.json": 46908,
	"./noon-chai": 27099,
	"./noon-chai.json": 27099,
	"./north-pole": 86465,
	"./north-pole.json": 86465,
	"./norwegian-glogg": 67784,
	"./norwegian-glogg.json": 67784,
	"./nutella-milkshake": 25212,
	"./nutella-milkshake.json": 25212,
	"./oatmilk-shaken-espresso": 14326,
	"./oatmilk-shaken-espresso.json": 14326,
	"./old-cuban": 24382,
	"./old-cuban.json": 24382,
	"./old-fashioned": 68662,
	"./old-fashioned.json": 68662,
	"./orange-carrot-smoothie": 15764,
	"./orange-carrot-smoothie.json": 15764,
	"./orange-earl-grey-iced-tea": 42871,
	"./orange-earl-grey-iced-tea.json": 42871,
	"./orange-glorius": 56699,
	"./orange-glorius.json": 56699,
	"./orange-ouzo-cocktail": 87130,
	"./orange-ouzo-cocktail.json": 87130,
	"./orange-pineapple-moscow-mule": 18139,
	"./orange-pineapple-moscow-mule.json": 18139,
	"./orangeade": 59237,
	"./orangeade.json": 59237,
	"./oreo-frappe": 13993,
	"./oreo-frappe.json": 13993,
	"./oreo-milkshake": 54238,
	"./oreo-milkshake.json": 54238,
	"./orgasm": 16188,
	"./orgasm.json": 16188,
	"./ozark-speedball": 78831,
	"./ozark-speedball.json": 78831,
	"./p2": 91015,
	"./p2.json": 91015,
	"./paan-shot": 44928,
	"./paan-shot.json": 44928,
	"./painkiller": 5054,
	"./painkiller.json": 5054,
	"./palembang-red-bean-ice": 64967,
	"./palembang-red-bean-ice.json": 64967,
	"./palm-sugar-sharbat": 70012,
	"./palm-sugar-sharbat.json": 70012,
	"./paloma": 50457,
	"./paloma.json": 50457,
	"./panty-ripper": 50208,
	"./panty-ripper.json": 50208,
	"./papaya-gin-sling": 10960,
	"./papaya-gin-sling.json": 10960,
	"./papaya-milk": 1889,
	"./papaya-milk.json": 1889,
	"./paper-plane": 38338,
	"./paper-plane.json": 38338,
	"./passion-star-martini": 74050,
	"./passion-star-martini.json": 74050,
	"./peach-bellini": 17306,
	"./peach-bellini.json": 17306,
	"./peach-fizz": 80672,
	"./peach-fizz.json": 80672,
	"./peach-green-tea-lemonade": 83447,
	"./peach-green-tea-lemonade.json": 83447,
	"./peach-martini": 90773,
	"./peach-martini.json": 90773,
	"./peach-ring-shot": 85434,
	"./peach-ring-shot.json": 85434,
	"./peach-thyme-whiskey-smash": 84044,
	"./peach-thyme-whiskey-smash.json": 84044,
	"./peanut-butter-banana-smoothie": 95280,
	"./peanut-butter-banana-smoothie.json": 95280,
	"./pear-manhattan-cocktail": 14805,
	"./pear-manhattan-cocktail.json": 14805,
	"./penicillin": 56336,
	"./penicillin.json": 56336,
	"./peppermint-bark-mimosa": 99703,
	"./peppermint-bark-mimosa.json": 99703,
	"./peppermint-shake": 40986,
	"./peppermint-shake.json": 40986,
	"./pick-a-daisy": 80909,
	"./pick-a-daisy.json": 80909,
	"./pickleback-shot": 28755,
	"./pickleback-shot.json": 28755,
	"./pimms": 58989,
	"./pimms.json": 58989,
	"./pina-colada": 52120,
	"./pina-colada.json": 52120,
	"./pineapple-juice": 76144,
	"./pineapple-juice.json": 76144,
	"./pineapple-lemonade": 47001,
	"./pineapple-lemonade.json": 47001,
	"./pineapple-lime-beer-margarita": 80389,
	"./pineapple-lime-beer-margarita.json": 80389,
	"./pineapple-shot": 40316,
	"./pineapple-shot.json": 40316,
	"./pineapple-upside-down-shot": 78856,
	"./pineapple-upside-down-shot.json": 78856,
	"./pink-gin": 4546,
	"./pink-gin.json": 4546,
	"./pink-grapefruit-margarita": 83852,
	"./pink-grapefruit-margarita.json": 83852,
	"./pink-lady": 92808,
	"./pink-lady.json": 92808,
	"./pink-ouzo": 92419,
	"./pink-ouzo.json": 92419,
	"./pisco-sour": 51833,
	"./pisco-sour.json": 51833,
	"./planters-punch": 9707,
	"./planters-punch.json": 9707,
	"./pok-shot": 87364,
	"./pok-shot.json": 87364,
	"./polar-bear": 43644,
	"./polar-bear-danish": 99466,
	"./polar-bear-danish.json": 99466,
	"./polar-bear.json": 43644,
	"./pomegranate-lemon-mint": 93929,
	"./pomegranate-lemon-mint.json": 93929,
	"./pomegranate-margarita": 37851,
	"./pomegranate-margarita.json": 37851,
	"./pomegranate-martini": 12035,
	"./pomegranate-martini.json": 12035,
	"./pompous-mexican": 35966,
	"./pompous-mexican.json": 35966,
	"./pornstar-martini": 88923,
	"./pornstar-martini.json": 88923,
	"./port-tonic": 41426,
	"./port-tonic.json": 41426,
	"./pudina-sherbet": 26910,
	"./pudina-sherbet.json": 26910,
	"./puka-punch": 4027,
	"./puka-punch.json": 4027,
	"./pumpkin-juice": 86130,
	"./pumpkin-juice.json": 86130,
	"./pumpkin-spice-latte": 76055,
	"./pumpkin-spice-latte.json": 76055,
	"./pumpkintini": 57341,
	"./pumpkintini.json": 57341,
	"./purple-basil-sherbet": 72211,
	"./purple-basil-sherbet.json": 72211,
	"./purple-haze": 38044,
	"./purple-haze.json": 38044,
	"./queimada": 96544,
	"./queimada.json": 96544,
	"./quick-demise": 72870,
	"./quick-demise.json": 72870,
	"./quick-milk-tea": 38387,
	"./quick-milk-tea.json": 38387,
	"./rabo-de-galo": 10637,
	"./rabo-de-galo.json": 10637,
	"./ramos-gin-fizz": 59888,
	"./ramos-gin-fizz.json": 59888,
	"./ranch-water": 85367,
	"./ranch-water.json": 85367,
	"./raspberry-caipirinha": 1958,
	"./raspberry-caipirinha.json": 1958,
	"./raspberry-drink": 38082,
	"./raspberry-drink.json": 38082,
	"./rebujito": 32165,
	"./rebujito.json": 32165,
	"./red-stag-dirty-shirley": 80414,
	"./red-stag-dirty-shirley.json": 80414,
	"./red-velvet-hot-chocolate": 46292,
	"./red-velvet-hot-chocolate.json": 46292,
	"./red-wine-spritzer": 4414,
	"./red-wine-spritzer.json": 4414,
	"./resentin": 42821,
	"./resentin.json": 42821,
	"./rich-hot-cocoa": 18843,
	"./rich-hot-cocoa.json": 18843,
	"./rob-roy": 37967,
	"./rob-roy.json": 37967,
	"./romulan-ale": 82750,
	"./romulan-ale.json": 82750,
	"./rooh-afza-milkshake": 35752,
	"./rooh-afza-milkshake.json": 35752,
	"./rooibos-peach-tea": 71125,
	"./rooibos-peach-tea.json": 71125,
	"./rooibos-punch": 87487,
	"./rooibos-punch.json": 87487,
	"./rose-milk": 79282,
	"./rose-milk.json": 79282,
	"./rose-sangria": 42378,
	"./rose-sangria.json": 42378,
	"./rosemary-horses-neck": 8414,
	"./rosemary-horses-neck.json": 8414,
	"./rosemarycano": 36130,
	"./rosemarycano.json": 36130,
	"./rossini": 77402,
	"./rossini.json": 77402,
	"./rosy-gin-kombucha-cocktail": 93227,
	"./rosy-gin-kombucha-cocktail.json": 93227,
	"./royal-milk-tea": 27695,
	"./royal-milk-tea.json": 27695,
	"./royal-mojito": 84363,
	"./royal-mojito.json": 84363,
	"./rum-and-coke": 77860,
	"./rum-and-coke.json": 77860,
	"./rum-old-fashioned": 38843,
	"./rum-old-fashioned.json": 38843,
	"./rum-punch": 36254,
	"./rum-punch.json": 36254,
	"./rumchata-bourbon": 44638,
	"./rumchata-bourbon.json": 44638,
	"./rumple-minze-shot": 65549,
	"./rumple-minze-shot.json": 65549,
	"./rusty-nail": 77185,
	"./rusty-nail.json": 77185,
	"./rye-tai": 7376,
	"./rye-tai.json": 7376,
	"./rysgaards-corona-special": 73268,
	"./rysgaards-corona-special.json": 73268,
	"./safari-coke": 73482,
	"./safari-coke.json": 73482,
	"./salty-grapefruit-refresher": 67717,
	"./salty-grapefruit-refresher.json": 67717,
	"./sambharam": 72371,
	"./sambharam.json": 72371,
	"./sangria": 95358,
	"./sangria.json": 95358,
	"./savage-banana-soup": 88046,
	"./savage-banana-soup.json": 88046,
	"./sayran": 7029,
	"./sayran.json": 7029,
	"./sazerac": 20866,
	"./sazerac.json": 20866,
	"./sbagliato": 58723,
	"./sbagliato.json": 58723,
	"./scivolo": 89780,
	"./scivolo.json": 89780,
	"./scotch-soda": 59779,
	"./scotch-soda.json": 59779,
	"./screamsicle": 82198,
	"./screamsicle.json": 82198,
	"./screwdriver": 10889,
	"./screwdriver.json": 10889,
	"./sea-breeze": 67768,
	"./sea-breeze.json": 67768,
	"./selendang-mayang": 3764,
	"./selendang-mayang.json": 3764,
	"./sergeant-pepper": 82453,
	"./sergeant-pepper.json": 82453,
	"./serviceberry-sour": 12266,
	"./serviceberry-sour.json": 12266,
	"./seven-devils": 11974,
	"./seven-devils.json": 11974,
	"./sex-in-the-driveway": 91317,
	"./sex-in-the-driveway.json": 91317,
	"./sex-on-the-beach": 7827,
	"./sex-on-the-beach.json": 7827,
	"./sgroppino": 77096,
	"./sgroppino.json": 77096,
	"./shandy": 98470,
	"./shandy.json": 98470,
	"./shembot": 61645,
	"./shembot.json": 61645,
	"./shikanji": 52316,
	"./shikanji.json": 52316,
	"./shirley-temple": 22185,
	"./shirley-temple.json": 22185,
	"./sidecar": 23104,
	"./sidecar.json": 23104,
	"./singapore-sling": 52393,
	"./singapore-sling.json": 52393,
	"./skeleton-key-cocktail": 43921,
	"./skeleton-key-cocktail.json": 43921,
	"./slippery-nipple": 64430,
	"./slippery-nipple.json": 64430,
	"./sloe-tom-collins": 85660,
	"./sloe-tom-collins.json": 85660,
	"./smirnoff-black-russian": 82727,
	"./smirnoff-black-russian.json": 82727,
	"./snake-bite": 72168,
	"./snake-bite.json": 72168,
	"./snowball-cocktail": 32420,
	"./snowball-cocktail.json": 32420,
	"./soju-sprite-yakult": 87061,
	"./soju-sprite-yakult.json": 87061,
	"./solkadhi": 80800,
	"./solkadhi.json": 80800,
	"./somaek": 42685,
	"./somaek.json": 42685,
	"./sonic-screwdriver": 25672,
	"./sonic-screwdriver.json": 25672,
	"./sour-apple-martini": 90662,
	"./sour-apple-martini.json": 90662,
	"./south-african-ginger-beer": 97191,
	"./south-african-ginger-beer.json": 97191,
	"./southside": 23701,
	"./southside.json": 23701,
	"./spaghett": 86145,
	"./spaghett.json": 86145,
	"./sparkling-campari-orange": 11679,
	"./sparkling-campari-orange.json": 11679,
	"./sparkling-fall-sangria": 37108,
	"./sparkling-fall-sangria.json": 37108,
	"./sparkling-punch": 54071,
	"./sparkling-punch.json": 54071,
	"./spezi": 21384,
	"./spezi.json": 21384,
	"./spiced-harvest-fall-sangria": 88179,
	"./spiced-harvest-fall-sangria.json": 88179,
	"./spicy-grapefruit-margarita": 70232,
	"./spicy-grapefruit-margarita.json": 70232,
	"./spicy-red-beer": 49908,
	"./spicy-red-beer.json": 49908,
	"./spicy-tamarind-margarita": 66797,
	"./spicy-tamarind-margarita.json": 66797,
	"./spicyorange": 68487,
	"./spicyorange.json": 68487,
	"./springbokkie": 91467,
	"./springbokkie.json": 91467,
	"./spritz": 19765,
	"./spritz-pomegranate": 47007,
	"./spritz-pomegranate.json": 47007,
	"./spritz.json": 19765,
	"./stinger": 91085,
	"./stinger.json": 91085,
	"./stmj": 56313,
	"./stmj.json": 56313,
	"./stone-sour": 76852,
	"./stone-sour.json": 76852,
	"./stoned-gimlet": 40265,
	"./stoned-gimlet.json": 40265,
	"./straight-tequila-shot": 55732,
	"./straight-tequila-shot.json": 55732,
	"./straight-whiskey-shot": 7799,
	"./straight-whiskey-shot.json": 7799,
	"./strawberry-banana": 71614,
	"./strawberry-banana.json": 71614,
	"./strawberry-cheesecake-shot": 50209,
	"./strawberry-cheesecake-shot.json": 50209,
	"./strawberry-daiquiri": 1101,
	"./strawberry-daiquiri.json": 1101,
	"./strawberry-ginger-turmeric-tea": 7956,
	"./strawberry-ginger-turmeric-tea.json": 7956,
	"./strawberry-limeade": 1042,
	"./strawberry-limeade.json": 1042,
	"./strawberry-margarita": 44943,
	"./strawberry-margarita.json": 44943,
	"./strawberry-mojita": 92645,
	"./strawberry-mojita.json": 92645,
	"./strawberry-saquerinha": 40518,
	"./strawberry-saquerinha.json": 40518,
	"./strawberry-sunrise-smoothie": 42117,
	"./strawberry-sunrise-smoothie.json": 42117,
	"./strawberry-watermelon-juice": 90068,
	"./strawberry-watermelon-juice.json": 90068,
	"./submarino": 56113,
	"./submarino.json": 56113,
	"./sugarcane-juice": 1169,
	"./sugarcane-juice.json": 1169,
	"./sunshine-cocktail": 16145,
	"./sunshine-cocktail.json": 16145,
	"./swan-song-cocktail": 19195,
	"./swan-song-cocktail.json": 19195,
	"./swedish-libre": 32349,
	"./swedish-libre.json": 32349,
	"./sweet-dreams": 88786,
	"./sweet-dreams.json": 88786,
	"./sweet-lassi": 58034,
	"./sweet-lassi.json": 58034,
	"./swinging-sultan": 52733,
	"./swinging-sultan.json": 52733,
	"./targoviste-twist": 69805,
	"./targoviste-twist.json": 69805,
	"./taro-fresh-milk": 51992,
	"./taro-fresh-milk.json": 51992,
	"./taste-the-rainbow": 78785,
	"./taste-the-rainbow.json": 78785,
	"./tea-ais": 77859,
	"./tea-ais.json": 77859,
	"./teh-c": 70450,
	"./teh-c.json": 70450,
	"./teh-tarik": 48256,
	"./teh-tarik.json": 48256,
	"./tequila-honeysuckle": 76971,
	"./tequila-honeysuckle.json": 76971,
	"./tequila-mocking-bird": 75837,
	"./tequila-mocking-bird.json": 75837,
	"./tequila-pineapple": 82603,
	"./tequila-pineapple.json": 82603,
	"./tequila-slammer": 36730,
	"./tequila-slammer.json": 36730,
	"./tequila-sunrise": 44718,
	"./tequila-sunrise.json": 44718,
	"./terere": 37098,
	"./terere.json": 37098,
	"./thai-tea-with-almond-milk": 45575,
	"./thai-tea-with-almond-milk.json": 45575,
	"./thandai": 40224,
	"./thandai.json": 40224,
	"./the-bengal-tiger": 97222,
	"./the-bengal-tiger.json": 97222,
	"./the-diddy": 62503,
	"./the-diddy.json": 62503,
	"./the-flaming-homer": 25227,
	"./the-flaming-homer.json": 25227,
	"./the-last-word": 62690,
	"./the-last-word.json": 62690,
	"./the-perfect-storm": 71196,
	"./the-perfect-storm.json": 71196,
	"./the-salty-dog": 52489,
	"./the-salty-dog.json": 52489,
	"./the-swedish-tart": 94198,
	"./the-swedish-tart.json": 94198,
	"./thyme-to-kill": 35407,
	"./thyme-to-kill.json": 35407,
	"./tinto-de-verano": 38605,
	"./tinto-de-verano.json": 38605,
	"./toddy-coconut": 27649,
	"./toddy-coconut.json": 27649,
	"./tom-collins": 21968,
	"./tom-collins.json": 21968,
	"./tom-yum": 10755,
	"./tom-yum.json": 10755,
	"./tomato-ricard": 47417,
	"./tomato-ricard.json": 47417,
	"./tongba": 43986,
	"./tongba.json": 43986,
	"./tornado-twist": 58904,
	"./tornado-twist.json": 58904,
	"./traffic-light-shot": 36182,
	"./traffic-light-shot.json": 36182,
	"./trash-can": 33686,
	"./trash-can.json": 33686,
	"./tropical-sangria": 78873,
	"./tropical-sangria.json": 78873,
	"./tropical-smoothie": 2420,
	"./tropical-smoothie.json": 2420,
	"./tschunk": 96145,
	"./tschunk.json": 96145,
	"./turkish-buttermilk": 22631,
	"./turkish-buttermilk.json": 22631,
	"./turmeric-latte": 21907,
	"./turmeric-latte.json": 21907,
	"./tuxedo": 69136,
	"./tuxedo.json": 69136,
	"./two-one-two": 56559,
	"./two-one-two.json": 56559,
	"./umeshu-sparkling": 35864,
	"./umeshu-sparkling.json": 35864,
	"./urak": 25582,
	"./urak.json": 25582,
	"./vaca-preta": 16215,
	"./vaca-preta.json": 16215,
	"./vampiro": 543,
	"./vampiro.json": 543,
	"./vanilla-palm": 85439,
	"./vanilla-palm.json": 85439,
	"./vegan-iced-milk-tea": 82531,
	"./vegan-iced-milk-tea.json": 82531,
	"./vegas-bomb": 57172,
	"./vegas-bomb.json": 57172,
	"./velvet-elvis": 92035,
	"./velvet-elvis.json": 92035,
	"./venom": 61974,
	"./venom.json": 61974,
	"./venus-flytrap": 85649,
	"./venus-flytrap.json": 85649,
	"./vesper": 8524,
	"./vesper.json": 8524,
	"./vietnamese-coffee": 44477,
	"./vietnamese-coffee.json": 44477,
	"./vieux-carre": 95596,
	"./vieux-carre.json": 95596,
	"./vinho-quente": 1500,
	"./vinho-quente.json": 1500,
	"./virgin-belgian-orange-blossom": 96110,
	"./virgin-belgian-orange-blossom.json": 96110,
	"./virgin-margarita": 14683,
	"./virgin-margarita.json": 14683,
	"./virgin-mary": 76780,
	"./virgin-mary.json": 76780,
	"./virgin-mojito": 71707,
	"./virgin-mojito.json": 71707,
	"./virgin-strawberry-colada": 67523,
	"./virgin-strawberry-colada.json": 67523,
	"./vodka-irish-coffee": 2265,
	"./vodka-irish-coffee.json": 2265,
	"./vodka-lemonade-punch": 48993,
	"./vodka-lemonade-punch.json": 48993,
	"./vodka-martini": 89405,
	"./vodka-martini.json": 89405,
	"./vodka-red-bull": 8746,
	"./vodka-red-bull.json": 8746,
	"./vodka-schweppes": 8857,
	"./vodka-schweppes.json": 8857,
	"./vodka-soda": 67324,
	"./vodka-soda.json": 67324,
	"./warm-lemon-honey-tea": 89527,
	"./warm-lemon-honey-tea.json": 89527,
	"./warm-water": 99186,
	"./warm-water.json": 99186,
	"./washington-apple": 46818,
	"./washington-apple.json": 46818,
	"./water-chestnut-drink": 7088,
	"./water-chestnut-drink.json": 7088,
	"./watermelon-agua-fresca": 67003,
	"./watermelon-agua-fresca.json": 67003,
	"./watermelon-lemonade": 80159,
	"./watermelon-lemonade.json": 80159,
	"./watermelon-mint-lemonade": 66200,
	"./watermelon-mint-lemonade.json": 66200,
	"./watermelon-moscow-mule": 9768,
	"./watermelon-moscow-mule.json": 9768,
	"./watermelon-smoothie": 40614,
	"./watermelon-smoothie.json": 40614,
	"./watermelon-vodka": 68099,
	"./watermelon-vodka.json": 68099,
	"./wedang-uwuh": 71405,
	"./wedang-uwuh.json": 71405,
	"./werthers-hot-toddies": 16184,
	"./werthers-hot-toddies.json": 16184,
	"./whiskey-boulevardier": 53682,
	"./whiskey-boulevardier.json": 53682,
	"./whiskey-highball": 93557,
	"./whiskey-highball.json": 93557,
	"./whiskey-smash": 28652,
	"./whiskey-smash.json": 28652,
	"./whiskey-sour-vegas-style": 28234,
	"./whiskey-sour-vegas-style.json": 28234,
	"./whisky-sour": 26636,
	"./whisky-sour.json": 26636,
	"./white-bear": 54271,
	"./white-bear.json": 54271,
	"./white-christmas-margarita": 88112,
	"./white-christmas-margarita.json": 88112,
	"./white-christmas-mojito": 96514,
	"./white-christmas-mojito.json": 96514,
	"./white-freezie": 31889,
	"./white-freezie.json": 31889,
	"./white-lady": 64861,
	"./white-lady.json": 64861,
	"./white-russian": 37054,
	"./white-russian.json": 37054,
	"./white-wine-sangria": 29728,
	"./white-wine-sangria.json": 29728,
	"./witches-heart": 78285,
	"./witches-heart.json": 78285,
	"./woo-woo": 26961,
	"./woo-woo.json": 26961,
	"./yale-cocktail": 66661,
	"./yale-cocktail.json": 66661,
	"./yellow-watermelon-juice": 15707,
	"./yellow-watermelon-juice.json": 15707,
	"./yogurt-fruit-shake": 22571,
	"./yogurt-fruit-shake.json": 22571,
	"./yogurt-lassi": 62598,
	"./yogurt-lassi.json": 62598,
	"./zanzibar-ricard": 75616,
	"./zanzibar-ricard.json": 75616,
	"./zombie": 64215,
	"./zombie.json": 64215,
	"./zorbatini": 73335,
	"./zorbatini.json": 73335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29606;